module.exports = __webpack_public_path__ + "images/revo2-c75daaed57bd9f12da81f81bc46c4242.jpg";